{
  "resetAbortMessage": "No",
  "resetConfirmMessage": "Yes, start over",
  "resetQuestionDescription": "The code will return to its original state and all changes will be undone.",
  "resetQuestionMessage": "Do you really want to start over?"
}
